"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendBuildsRequests = void 0;
const lodash_1 = __importDefault(require("lodash"));
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
class BackendBuildsRequests {
    constructor(session, appInfo) {
        this.session = session;
        this.appInfo = appInfo;
        this.options = new OptionsHandler_1.OptionsHandler(this.appInfo);
    }
    getBuilds() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const endpoint = this.getRootEventEndpoint();
            return this.makeRequest(endpoint, options);
        });
    }
    getBuildsWithParams(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            Object.entries(params).forEach(([key, value]) => {
                if (value === undefined) {
                    delete params[key];
                }
            });
            const endpoint = this.getRootEventEndpoint({ params });
            return this.makeRequest(endpoint, options);
        });
    }
    getBuildById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const endpoint = this.getRootEventEndpoint({ id });
            return this.makeRequest(endpoint, options);
        });
    }
    addBuild(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body,
            };
            const endpoint = this.getRootEventEndpoint();
            return this.makeRequest(endpoint, options);
        });
    }
    makeRequest(endpoint, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, this.options);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getRootEventEndpoint(opts) {
        const base = `${this.session.baseUrl}/${Paths_1.Constants.V2_BUILDS}`;
        if (opts === null || opts === void 0 ? void 0 : opts.id) {
            return `${base}/${opts.id}`;
        }
        else if ((opts === null || opts === void 0 ? void 0 : opts.params) && !lodash_1.default.isEqual(opts.params, {})) {
            const urlParams = new URLSearchParams();
            Object.entries(opts.params).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((element) => {
                        urlParams.append(key, element);
                    });
                }
                else {
                    urlParams.append(key, value);
                }
            });
            return `${base}?${urlParams.toString()}`;
        }
        else {
            return base;
        }
    }
}
exports.BackendBuildsRequests = BackendBuildsRequests;
//# sourceMappingURL=BackendBuilds.js.map